var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-item-1",style:({..._vm.padding})},[_c('div',{staticClass:"video rounded",style:({..._vm.shadow})},[_vm._t("video")],2),_vm._t("title"),(_vm.visability('subtitle'))?_vm._t("subtitle"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }